/*
  Quiz teinte Mood Lentilles.
  Trois questions : profondeur de l'iris, effet voulu, correction.
  Chaque resultat renvoie vers la ou les fiches produit ; aucune ecriture
  panier ici, la logique correction / quantites paires reste geree par
  buy-buttons.
  Bilingue : les textes par defaut sont en francais (QuizTeinte.TEXTES) ;
  la section fournit les textes italiens dans le bloc data-mq-i18n.
*/
class QuizTeinte extends HTMLElement {
  connectedCallback() {
    this.teintes = JSON.parse(this.querySelector('[data-mq-teintes]').textContent);
    const blocTextes = this.querySelector('[data-mq-i18n]');
    this.t = Object.assign({}, QuizTeinte.TEXTES, blocTextes ? JSON.parse(blocTextes.textContent) : {});
    this.etapes = Array.from(this.querySelectorAll('[data-mq-step]'));
    this.scene = this.querySelector('[data-mq-scene]');
    this.result = this.querySelector('[data-mq-result]');
    this.segments = Array.from(this.querySelectorAll('[data-mq-seg]'));
    this.compte = this.querySelector('[data-mq-compte]');
    this.retour = this.querySelector('[data-mq-retour]');
    this.reponses = {};
    this.courant = 0;

    this.addEventListener('change', this.onChange.bind(this));
    this.retour.addEventListener('click', () => this.afficher(this.courant - 1));
    this.querySelector('[data-mq-refaire]').addEventListener('click', this.reinitialiser.bind(this));

    this.afficher(0);
  }

  afficher(index) {
    if (index < 0 || index >= this.etapes.length) return;
    this.courant = index;
    this.etapes.forEach((etape, i) => etape.classList.toggle('is-active', i === index));
    this.segments.forEach((seg, i) => seg.classList.toggle('is-faite', i <= index));
    this.retour.disabled = index === 0;
    if (this.compte) this.compte.textContent = index + 1 + '/' + this.etapes.length;

    const titre = this.etapes[index].querySelector('.mq__q');
    if (titre) titre.focus({ preventScroll: true });
  }

  onChange(event) {
    const input = event.target.closest('[data-mq-input]');
    if (!input) return;
    this.reponses[input.name] = input.value;
    setTimeout(() => {
      if (this.courant < this.etapes.length - 1) this.afficher(this.courant + 1);
      else this.conclure();
    }, 260);
  }

  reinitialiser() {
    this.reponses = {};
    this.querySelectorAll('[data-mq-input]').forEach((input) => {
      input.checked = false;
    });
    this.result.hidden = true;
    this.scene.hidden = false;
    this.afficher(0);
    this.scene.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  conclure() {
    const t = this.t;
    const cle = this.reponses.iris + '|' + this.reponses.rendu;
    const liste = QuizTeinte.MATRICE[cle];
    if (!liste) return;

    const avecCorrection = this.reponses.correction === 'avec';
    const champ = avecCorrection ? 'avec' : 'sans';
    const meta = avecCorrection ? t.avec : t.sans;

    this.querySelector('[data-mq-titre]').textContent =
      (t.mots[liste.length] || liste.length + t.teintes) +
      (liste.length > 1 ? t.plusieurs : t.une);
    this.querySelector('[data-mq-lead]').textContent = t.pourquoi[cle];

    const grille = this.querySelector('[data-mq-fiches]');
    grille.dataset.nb = liste.length;
    grille.textContent = '';

    liste.forEach((id, rang) => {
      const teinte = this.teintes[id];
      const offre = teinte[champ];

      const fiche = document.createElement('article');
      fiche.className = 'mq__fiche' + (rang === 0 ? ' mq__fiche--premier' : '');

      const cadrePhoto = document.createElement('div');
      cadrePhoto.className = 'mq__fiche-photo';
      if (offre.photo) {
        const img = document.createElement('img');
        img.src = offre.photo;
        img.alt = t.altAvant + teinte.nom + t.altApres;
        img.loading = 'lazy';
        cadrePhoto.appendChild(img);
      }
      if (rang === 0 && liste.length > 1) {
        const badge = document.createElement('span');
        badge.className = 'mq__fiche-badge';
        badge.textContent = t.badge;
        cadrePhoto.appendChild(badge);
      }

      const corps = document.createElement('div');
      corps.className = 'mq__fiche-corps';

      const nom = document.createElement('h3');
      nom.className = 'mq__fiche-nom';
      nom.textContent = teinte.nom;

      const txt = document.createElement('p');
      txt.className = 'mq__fiche-txt';
      txt.textContent = teinte.phrase;

      const prix = document.createElement('p');
      prix.className = 'mq__fiche-prix';
      prix.textContent = offre.prix + ' ';
      const detail = document.createElement('span');
      detail.textContent = '· ' + meta + ' · ' + t.duree;
      prix.appendChild(detail);

      const pied = document.createElement('div');
      pied.className = 'mq__fiche-cta';
      const cta = document.createElement('a');
      cta.className = 'mq__bouton' + (rang === 0 ? '' : ' mq__bouton--secondaire');
      cta.href = offre.url;
      cta.textContent = t.cta;
      pied.appendChild(cta);

      corps.append(nom, txt, prix, pied);
      fiche.append(cadrePhoto, corps);
      grille.appendChild(fiche);
    });

    this.scene.hidden = true;
    this.result.hidden = false;
    this.result.scrollIntoView({ behavior: 'smooth', block: 'center' });

    // Permet une relance Klaviyo ciblee sur la teinte recommandee.
    if (window._learnq) {
      window._learnq.push([
        'track',
        'Quiz Teinte Termine',
        {
          Teinte: this.teintes[liste[0]].nom,
          Iris: this.reponses.iris,
          Rendu: this.reponses.rendu,
          Correction: this.reponses.correction,
          Teintes: liste.map((id) => this.teintes[id].nom),
          TeinteId: liste[0],
          Langue: document.documentElement.lang || 'fr',
        },
      ]);
    }
  }
}

/*
  Profondeur de l'iris x effet voulu, de la teinte la plus recommandee a la
  moins. Matrice arbitree par Elias, deux regles fermes : jamais Marron
  Noisette sur un iris clair, et Bleu Vif reste en rendu naturel pour les iris
  clairs.
*/
QuizTeinte.MATRICE = {
  'clair|naturel': ['vert-opaline', 'gris-perle', 'bleu-vif'],
  'clair|assume': ['vert-jade', 'bleu-ciel'],
  'moyen|naturel': ['marron-noisette', 'vert-opaline', 'bleu-ciel'],
  'moyen|assume': ['gris-perle', 'bleu-vif'],
  'fonce|naturel': ['marron-noisette', 'vert-jade'],
  'fonce|assume': ['gris-perle', 'bleu-ciel', 'bleu-vif'],
};

QuizTeinte.TEXTES = {
  avec: 'Avec correction',
  sans: 'Sans correction',
  duree: '3 mois',
  mots: { 1: 'Une teinte', 2: 'Deux teintes', 3: 'Trois teintes' },
  plusieurs: ' vous correspondent',
  une: ' vous correspond',
  teintes: ' teintes',
  altAvant: 'Lentilles de couleur ',
  altApres: ' portées',
  badge: 'Notre premier choix',
  cta: 'Voir cette teinte',
  pourquoi: {
    'clair|naturel':
      "Sur un iris clair, la couleur se dépose sans lutter contre le fond. Le regard change de température, pas d'identité.",
    'clair|assume':
      'Assez denses pour couvrir un iris clair et imposer une nouvelle couleur, sans virer au masque.',
    'moyen|naturel':
      "Votre iris a déjà de la matière. Ces teintes jouent avec, l'éclaircissent par endroits, et gardent une profondeur crédible.",
    'moyen|assume':
      'Le contraste avec votre iris est net, la couleur prend le dessus. Cela se voit dès le premier regard.',
    'fonce|naturel':
      "Sur un iris marron, ces teintes se fondent et réchauffent le regard sans effet de superposition.",
    'fonce|assume':
      "Un changement qui se voit en plein jour. Sur un iris foncé, ces teintes assument le contraste.",
  },
};

if (!customElements.get('quiz-teinte')) {
  customElements.define('quiz-teinte', QuizTeinte);
}
